const ITEMS = ["STIL", "ELEGANȚĂ", "PROFESIONALISM", "PRECIZIE", "BARBĂ", "SKIN FADE"];

export const Marquee = () => {
    const row = [...ITEMS, ...ITEMS];
    return (
        <div
            data-testid="marquee"
            className="relative overflow-hidden border-y border-white/10 bg-black py-8"
        >
            <div className="marquee-track">
                {row.map((word, i) => (
                    <div key={i} className="flex shrink-0 items-center">
                        <span className="font-display text-4xl font-semibold tracking-tight text-outline md:text-6xl">
                            {word}
                        </span>
                        <span className="mx-8 text-2xl text-gold md:mx-12 md:text-4xl">✦</span>
                    </div>
                ))}
            </div>
        </div>
    );
};
